<script setup lang="ts">
import type { NuxtError } from '#app'
const { path } = useRoute()
const store = useStore()

/** @TODO: czy da sie to inaczej? */
await callOnce(async () => {
  await store.init()
})

defineProps({
  error: Object as () => NuxtError
})

useHead({
  titleTemplate: 'Błąd 404 - %s',
  meta: [{ hid: 'description', name: 'description', content: 'Nie można odnaleźć strony' }]
})

const seachProducts = async (search: string, limit: number = 4) => {
  const { elements: products } = await $fetch('/store-api/search', {
    method: 'POST',
    body: {
      'no-aggregations': true,
      limit,
      search,
      order: 'topseller',
      associations: {
        media: {},
        seoUrls: {}
      },
      includes: {
        product: ['id', 'name', 'calculatedPrice', 'calculatedPrices', 'cover', 'customFields.product_city', 'urlPrefix', 'seoUrls'],
        calculated_cheapest_price: ['unitPrice'],
        product_media: ['media'],
        media: ['url', 'metaData', 'alt'],
        seo_url: ['seoPathInfo']
      }
    }   
  })

  return products
}

const { data: products } = useAsyncData('error-products', async () => {
  const [search, jazda] = await Promise.all([
    seachProducts(path, 4),
    seachProducts('jazda', 4)
  ])

  return [...search, ...jazda].slice(0, 4)
})
</script>

<template>
  <NuxtPwaAssets />
  <NuxtLayout>
    <div class="container mx-auto">
      <div class="flex flex-col items-center my-[30px]">
        <Img src="/404.png" width="824" height="243" alt="Strony nie znaleziono" />
        <div class="flex flex-col items-center mt-[10px] pb-[10px] text-center border-b border-gray-400">
          <h1 class="uppercase">
            Ta strona nie jest dostępna
          </h1>
          <p class="text-16 uppercase">
            Przykro nam, ale wpisany przez Ciebie adres nie jest już dostępny.
          </p>
        </div>
        <div class="my-[20px]">
          <NuxtLink to="/" custom #default="{ href }">
            <a :href="href" class="btn btn-secondary !px-[10px]" @click.prevent="clearError({ redirect: href })">
              <i class="icon-arrow-button -rotate-180" />
              Strona główna
            </a>
          </NuxtLink>
        </div>
        <ul class="flex flex-nowrap overflow-y-auto snap-x md:snap-none snap-mandatory mt-[10px] [--slide-spacing:5px] sm:[--slide-spacing:15px] lg:[--slide-spacing:30px] ml-[calc(var(--slide-spacing,0)*-1)]">
          <li v-for="product in products" :key="product.id" class="shrink-0 basis-3/5 sm:basis-2/5 md:basis-1/4 snap-center pl-[var(--slide-spacing,0)]">
            <ProductListItem :products="product" class="group max-w-[262px] mb-[30px]" />
          </li>
        </ul>
      </div>
    </div>
  </NuxtLayout>
</template>
